import Dashboard from '../modules/panel/dashboad/Dashboard'
import TransactionDetails from '../modules/panel/dashboad/Dashboard/TransactionDetails/TransactionDetails'
import RolesWrapper from '../modules/panel/roles/RolesWrapper'
import PermissionsPage from '../modules/panel/permissions/PermissionsPage'
import UsersPage from '../modules/panel/users/UsersPage'
import { Outlet } from 'react-router-dom'
import ViewRoleWrapper from '../modules/panel/roles/ViewRoleWrapper'
import { IntlShape } from 'react-intl'
import StoresPage from '../modules/panel/stores/StoresPage'
import ViewStoreWrapper from '../modules/panel/stores/ViewStoreWrapper'
import LogisticsPage from '../modules/panel/logistics/LogisticsPage'
import ViewLogistics from '../modules/panel/logistics/ViewLogistics'
import ActivitiesPage from '../modules/panel/activities/ActivitiesPage'
import PaymentDashboard from '../modules/panel/dashboad/Payments'
import PaymentSchemesDashboard from '../modules/panel/dashboad/Payments/PaymentSchemes'
import PaymentDetails from '../modules/panel/dashboad/Payments/PaymentDetails/PaymentDetails'
import PaymentSchemeDetails from '../modules/panel/dashboad/Payments/PaymentSchemes/PaymentSchemeDetails/PaymentSchemeDetails'
import PromotionsDashboard from '../modules/panel/promotions'
import PromotionDetails from '../modules/panel/promotions/PromotionDetails/PromotionDetails'
import CouponTransactionsDashboard from '../modules/panel/promotions/coupon-transactions/CouponTransactionsDashboardWrapper'
import CouponTransactionDetails from '../modules/panel/promotions/coupon-transactions/TransactionDetails/TransactionDetails'
import { Navigate } from 'react-router-dom'

export const getRoutes = (intl: IntlShape) => [
  {
    path: 'transactions',
    element: <Outlet />,
    children: [
      {
        index: true,
        title: intl.formatMessage({ id: 'FILTERS' }),
        element: <Dashboard />,
      },
      {
        path: ':id/details',
        title: intl.formatMessage({ id: 'PURCHASE.DETAILS' }),
        element: <TransactionDetails />,
      },
    ],
  },
  {
    path: 'logistics/:provider',
    element: <Outlet />,
    children: [
      {
        index: true,
        title: intl.formatMessage({ id: 'PARCEL.LIST' }),
        element: <LogisticsPage />,
      },
      {
        path: 'view/:logisticId',
        title: intl.formatMessage({ id: 'PARCEL.DETAILS' }),
        element: <ViewLogistics />,
      },
    ],
  },
  {
    path: 'users-management',
    element: <Outlet />,
    children: [
      {
        path: 'users',
        title: intl.formatMessage({ id: 'USERS.LIST' }),
        element: <UsersPage />,
      },
      {
        path: 'roles',
        title: intl.formatMessage({ id: 'ROLES.LIST' }),
        element: <RolesWrapper />,
      },
      {
        path: 'roles/view/:roleId',
        title: intl.formatMessage({ id: 'ROLE.DETAILS' }),
        element: <ViewRoleWrapper />,
      },
      {
        path: 'permissions',
        title: intl.formatMessage({ id: 'PERMISSIONS.LIST' }),
        children: [],
        element: <PermissionsPage />,
      },
      {
        path: 'activities',
        title: intl.formatMessage({ id: 'PERMISSIONS.LIST' }),
        children: [],
        element: <ActivitiesPage />,
      },
    ],
  },
  {
    path: 'stores-management',
    element: <Outlet />,
    children: [
      {
        index: true,
        title: intl.formatMessage({ id: 'STORES.LIST' }),
        element: <StoresPage />,
      },
      {
        path: 'view/:storeId',
        title: intl.formatMessage({ id: 'STORE.DETAILS' }),
        element: <ViewStoreWrapper />,
      }
    ],
  },
  {
    path: 'payments',
    element: <Outlet />,
    children: [
      {
        path: 'transactions',
        title: intl.formatMessage({ id: 'FILTERS' }),
        element: <PaymentDashboard />,
      },
      {
        path: 'schemes',
        title: intl.formatMessage({ id: 'FILTERS' }),
        element: <PaymentSchemesDashboard />,
      },
      {
        path: 'transactions/:id/details',
        title: intl.formatMessage({ id: 'PAYMENT.DETAILS' }),
        element: <PaymentDetails />,
      },
      {
        path: 'schemes/:id/details',
        title: intl.formatMessage({ id: 'PAYMENT.DETAILS' }),
        element: <PaymentSchemeDetails />,
      },
      {
        index: true,
        element: <Navigate to='transactions' />,
      },
    ],
  },
  {
    path: 'promotions',
    element: <Outlet />,
    children: [
      {
        path: 'schemas',
        title: intl.formatMessage({ id: 'FILTERS' }),
        element: <PromotionsDashboard />,
      },
      {
        path: 'transactions',
        title: intl.formatMessage({ id: 'FILTERS' }),
        element: <CouponTransactionsDashboard />,
      },
      {
        path: 'schemas/:id/details',
        title: intl.formatMessage({ id: 'PROMOTION.DETAILS' }),
        element: <PromotionDetails />,
      },
      {
        path: 'transactions/:id/details',
        title: intl.formatMessage({ id: 'PURCHASE.DETAILS' }),
        element: <CouponTransactionDetails />,
      },
      {
        index: true,
        element: <Navigate to='schemas' />,
      },
    ],
  },
]
